import React, { memo } from 'react';
import classNames from 'classnames/bind';
import { Text } from '@beef/ui-kit';
import styles from "./styles.module.pcss";
var cn = classNames.bind(styles);
export var ValueContent = /*#__PURE__*/memo(function (_ref) {
  var isDark = _ref.isDark,
    packageItem = _ref.packageItem,
    cardType = _ref.cardType,
    children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: cn('value', cardType && "value--".concat(cardType)),
    "data-t-id": "components-ValueContent"
  }, /*#__PURE__*/React.createElement("span", {
    className: cn('value__strong')
  }, children), /*#__PURE__*/React.createElement(Text, {
    color: isDark ? 'white' : 'grey60',
    size: cardType === 'default' ? 'size4-r' : 'size3-m'
  }, packageItem.unit));
});